const MONEY_DECIMALS = 2;

/** Arrotonda un importo ai centesimi, compensando i comuni errori IEEE-754. */
export function roundMoney(value: number): number {
  if (!Number.isFinite(value)) return value;
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

/** Valore adatto a un input numerico: mai più di due cifre decimali. */
export function moneyInputValue(
  value: number | null | undefined,
): string {
  if (value == null || !Number.isFinite(value)) return "";
  return String(roundMoney(value));
}

/** Importo leggibile in italiano, senza zeri decimali superflui. */
export function formatMoney(value: number): string {
  return roundMoney(value).toLocaleString("it-IT", {
    minimumFractionDigits: 0,
    maximumFractionDigits: MONEY_DECIMALS,
  });
}
